import React from 'react';
import { theme } from '@citygross/design-tokens';
import { Dot as Dot$1 } from './DotIndicator.styles.js';

var Dot = function Dot(_a) {
  var _b, _c;

  var _d = _a.color,
      color = _d === void 0 ? (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white : _d,
      shadow = _a.shadow,
      _e = _a.size,
      size = _e === void 0 ? (_c = theme.spacings) === null || _c === void 0 ? void 0 : _c.xs : _e;
  return React.createElement(Dot$1, {
    color: color,
    shadow: shadow,
    size: size
  });
};

export { Dot };